import * as React from "react";

import { Grid, Link, Typography } from "@mui/material";
import "./errorpage.scss";

interface ErrorInfo {
  title: string;
  errortext: string;
}
const ErrorPage = (props: ErrorInfo) => {
  const { title, errortext } = props;
  return (
    <Grid container className="containerbody">
      <Grid item className="itembody">
        <Typography className="pagenotfound">{title}</Typography>
        <Typography className="errortext">{errortext}</Typography>
        <Typography className="errortext">
          Reach out us at
          <Link sx={{ pl: 1 }} href="mailto:contact@employersforumindiana.org">
            contact@employersforumindiana.org
          </Link>{" "}
          for support.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
